<template>
  <div>
    <div>
      <div>
        <div class="is-flex is-align-items-center is-justify-content-space-between">
          <p><b>{{ label }}</b>
            <span v-if="hasMessageMetaInsideMessage()">
              &nbsp;(<b>עודכן פעם אחרונה</b> - {{time_helper.makeTimeReadable(getExtractedDateFromMessageMeta())}}  ע"י {{getExtractedOwnerFromMessageMeta()}})
            </span>
          </p>
          <div>
            <checkbox v-model="follow_up" :checked="follow_up">Follow Up</checkbox>
          </div>
        </div>
        <div class="is-flex">
          <div>
            <div>
              <textarea v-model="message" placeholder="Message"></textarea>
              <div class="m-0 p-0 is-size-7">{{ message_length_limit }} / {{ message.length }}</div>
            </div>
            <div v-if="payload.additional_data && payload.additional_data.resource_type == 'Offer'" class="mt-4">
              <textarea v-model="autoMessage" placeholder="Auto Message"></textarea>
            </div>
          </div>
          <div v-if="payload.triggerBtn" class="is-flex is-flex-direction-column is-justify-content-space-between my-2 mx-5">
            <div><button @click="updateText('experience')" class="button is-info mb-1 is-fullwidth">ניסיון</button></div>
            <div><button @click="updateText('salaryExpectations')" class="button is-info mb-1 is-fullwidth">צפ”ש</button></div>
            <div><button @click="updateText('locationMismatch')" class="button is-info mb-1 is-fullwidth">מרחק ג”ג</button></div>
            <div><button @click="updateText('overQualified')" class="button is-info mb-1 is-fullwidth">O.Q</button></div>
            <div v-if="parent != 'applicant'"><button @click="updateText('educationMismatch')" class="button is-info mb-1 is-fullwidth">Education</button></div>
          </div>
        </div>
      </div>
      <div class="horizontal_space"></div>
      <div class="mt-3 mb-5 has-text-left">
        <a
          v-if="payload.internal_submit_button"
          @click="submit()"
          :class="{ ...payload.internalSubmitButtonStyle, 'is-loading': is_loading }"
          class="button is-danger"
          :disabled="isMessageValid"
          >Submit</a
        >
      </div>
    </div>
    <div v-if="payload.is_submitable" class="modal_footer">
      <a
        @click="submit()"
        :class="{ 'is-loading': is_loading }"
        class="button is-info"
        :disabled="isMessageValid"
        >Submit</a
      >
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import TimeHelper from '@/custom/classes/time_helper.js'
import Checkbox from '@/components/Checkbox'
export default {
  name: 'MessageForm',
  props: {
    payload: {
      type: Object
    },
    label: {
      type: String,
      default: 'Message'
    },
    parent: {
      type: String,
      default: 'Message'
    },
    onSubmit: {
      type: Function,
      default: () => {}
    },
    fieldName: {
      type: String,
      default: 'message'
    }
  },
  data () {
    return {
      follow_up: false,
      time_helper: new TimeHelper(),
      is_loading: false,
      timing: new Date().toUTCString(),
      message: '',
      autoMessage: ''
    }
  },
  mounted () {
    this.setInitMessage()
  },
  computed: {
    message_length_limit () {
      if (this.payload.additional_data == undefined) {
        return 500
      }
      return this.payload.additional_data.resource_type == 'Offer' ? 250 : 500
    },
    isMessageValid () {
      return this.validateMessage(this.message)
    }
  },
  watch: {
    message (newVal, oldVal) {
      if (newVal.length > this.message_length_limit) {
        this.message = oldVal
        this.$emit('input', this.getSubmitMessage())
      }
    }
  },
  methods: {
    validateMessage (message) {
      return message.includes('XX')
    },
    setInitMessage () {
      if (this.payload.resource_data == undefined) {
        this.message = ''
        return
      }
      if (this.payload.resource_data.message == undefined) {
        this.message = ''
        return
      }
      this.message = this.removeMessageMetaFromMessage()
      this.autoMessage = this.payload.resource_data.auto_message
    },
    hasMessageMetaInsideMessage () {
      return this.payload.resource_data.message != undefined && this.getExtractedMessageMeta().length > 0
    },
    getExtractedMessageMeta () {
      return this.$utils.extractStringInsideHtmlTag(this.payload.resource_data.message, 'messsage-meta')
    },
    getExtractedDateFromMessageMeta () {
      return this.$utils.extractStringInsideHtmlTag(this.payload.resource_data.message, 'message-date')
    },
    getExtractedOwnerFromMessageMeta () {
      return this.$utils.extractStringInsideHtmlTag(this.payload.resource_data.message, 'owner')
    },
    removeMessageMetaFromMessage () {
      return this.payload.resource_data.message.replace('<messsage-meta>' + this.getExtractedMessageMeta() + '</messsage-meta>', '').replace('\n', '').replace('\n', '')
    },
    getSubmitMessage () {
      let submit_message = this.message + '\n\n' + this.appendMessageMeta()
      if (submit_message.length <= this.message_length_limit) {
        return submit_message
      }
      return this.message.substring(0, this.message_length_limit - this.appendMessageMeta().length) + this.appendMessageMeta()
    },
    getFullMessage () {
      return this.message
    },
    appendMessageMeta () {
      return '<messsage-meta><message-date>' + new Date() + '</message-date><owner>' + this.$utils.getOwner().name + '</owner></messsage-meta>'
    },
    getTiming () {
      return this.timing
    },
    updateText (key) {
      const messages = {
        experience: `חסר ניסיון נדרש, המשרה דורשת XX שנות ניסיון ב XX ולמועמד יש רק XX שנות ניסיון.\nפירוט:`,
        salaryExpectations: 'ציפיות השכר אינן תואמות',
        locationMismatch: 'מיקום ג”ג אינו תואם',
        overQualified: 'אובר קואוליפייד למשרה, למועמד יש XX שנות ניסיון.\nפירוט:',
        educationMismatch: 'חוסר התאמה בהשכלה'
      }
      this.message = messages[key]
    },
    async submit () {
      if (this.isMessageValid) return
      try {
        this.is_loading = true
        const updateData = {}
        updateData[this.fieldName] = this.getSubmitMessage()
        await this.$caller.request('put', '/' + this.payload.additional_data.endpoint + '/' + this.payload.resource_data.id, this.payload.additional_data.headers, updateData)
        if (this.payload.additional_data.resource_type == 'Offer') {
          await this.submitAutoMessage()
        }
        this.sendMessageChangedStat()
        this.onSubmit(this.payload.modal_id)
        this.remove(this.payload)
        this.$utils.emit('show_toast', { text: 'success' })
      } catch (error) {
        console.error('Submission failed', error)
      } finally {
        this.is_loading = false
      }
    },
    async submitAutoMessage () {
      await this.$caller.request('put', '/' + this.payload.additional_data.endpoint + '/' + this.payload.resource_data.id, this.payload.additional_data.headers, { auto_message: this.autoMessage })
    },
    getResourceId () {
      return ['Position', 'Offer'].includes(this.payload.additional_data.resource_type) ? this.payload.resource_data.id : this.payload.resource_data.resource_id
    },
    sendMessageChangedStat () {
      let old_message = this.payload.resource_data.message
      let new_message = this.getFullMessage()
      if (old_message == new_message) {
        return
      }
      let stat_content = 'Message Changed:<br><b>Old Message was:</b> ' + old_message + '<br><b>New Message is:</b> ' + new_message
      this.$network_utils.postStat({
        title: 'new internal note',
        designator: this.follow_up ? 'follow_up' : 'internal_notes',
        content: stat_content,
        status: 'done',
        owner: this.$utils.getOwner().name,
        priority: 7,
        resource_id: this.getResourceId(),
        resource_type: this.payload.additional_data.resource_type
      })
      if (!this.payload.resource_data.resource_type) return
      this.$network_utils.postStat({
        title: 'feed_message',
        designator: 'feed_message',
        content: stat_content,
        status: 'active',
        owner: this.$utils.getOwner().name,
        priority: 55,
        resource_id: this.payload.resource_data.resource_id,
        resource_type: this.payload.resource_data.resource_type
      })
    },
    ...mapMutations('modals', ['remove'])
  },
  components: {
    Checkbox
  }
}
</script>
